<template>
  <div v-if="template && template.disabled_at" class="row">
    <div class="col-sm-12">
      <div class="alert alert-danger" role="alert">
        <span>This Checklist template is disabled</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    template: { required: true, type: Object }
  }
}
</script>
